import React, { useState } from "react";
import './PasswordPage.css';

const PasswordPage = ({ onAccessGranted }) => {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        const correctPassword = process.env.REACT_APP_PASSWORD; // Password from .env
        if (password === correctPassword) {
            onAccessGranted(); // Grant access
        } else {
            setError("Incorrect password. Please try again.");
        }
    };

    return (
        <div className="password-page">
            <div className="password-form-container">
                <h1 className="password-title">Tim & Seneca's Wedding Website</h1>
                <form onSubmit={handleSubmit} className="password-form">
                    <input
                        type="password"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <br />
                    <button type="submit">Enter</button>
                </form>
                {error && <p className="password-error">{error}</p>}
            </div>
        </div>
    );
};

export default PasswordPage;
